import React from 'react';
import Manage from './Manage';
import { ExtVersionsProvider } from '../../../contexts/extractions/ExtVersionContext';
import { useLocation } from 'react-router-dom';
import ViewFullDataPage from '../view/ViewFullDataPage';
import OutputMappingsPage from '../view/OutputMappingsPage';

const Step4 = () => {
  const location = useLocation();
  const isViewRoute = location.pathname.includes('/extraction/view');
  const isViewFullDataRoute = location.pathname.includes('/extraction/view-full-data');

  return (
    <ExtVersionsProvider>
      {isViewFullDataRoute ? <ViewFullDataPage /> : isViewRoute ? <OutputMappingsPage /> : <Manage />}
    </ExtVersionsProvider>
  );
};

export default Step4;
